import React, { useState } from 'react';

const GSTReturnFiling = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formStatus, setFormStatus] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: 'I need help with GST Return Filing.',
    website_hp: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFormSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);
  
  try {
    const response = await fetch("https://akiradvisory.in/send_mail.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      setFormStatus('success');
      // Reset form while keeping the default message
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: 'I need help with GST Return Filing.',
        website_hp: ''
      });
    } else {
      setFormStatus('error');
    }
  } catch (error) {
    setFormStatus('error');
  } finally {
    setIsSubmitting(false);
    setTimeout(() => setFormStatus(''), 5000);
  }
};

  return (
    <main>
      {/* Hero Section */}
      <section className="relative bg-blue-700 pt-16 pb-12">
        <div className="absolute inset-0 opacity-10 bg-cover bg-center"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="lg:w-2/3">
            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-white leading-tight">
              GST Return Filing
            </h1>

            <p className="mt-4 text-xl text-blue-100">
              Comprehensive GST return filing services to ensure your business stays fully compliant with India's Goods and Services Tax regulations. We handle all GST returns including GSTR-1, GSTR-3B, GSTR-9, and reconciliation to keep your business penalty-free and compliant.
            </p>
            <div className="mt-8">
              <a href="#contact-section" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                  <span className="mr-2">✅</span> Stay GST Compliant, Avoid Penalties
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Sticky Navigation */}
      <section className="bg-gray-50 border-b border-gray-200 sticky top-16 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <ul className="flex space-x-6 overflow-x-auto text-sm font-medium">
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#details">Overview & Benefits</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#procedure">Filing Process</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#documents">Documents Required</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#you-get">What You Get</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#service-faqs">FAQs</a></li>
            </ul>
        </div>
      </section>

      {/* Overview Section */}
      <section id="details" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2 space-y-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4 border-b pb-2">
                Overview of GST Return Filing
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                Goods and Services Tax (GST) is a comprehensive indirect tax levied on the supply of goods and services in India. Regular GST return filing is mandatory for all registered businesses to maintain compliance and avoid penalties.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Our GST return filing service covers all types of returns including monthly GSTR-1 (outward supplies), GSTR-3B (summary return), annual GSTR-9, and reconciliation statements. We ensure accurate filing, timely payments, and complete compliance.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                With expert handling of GST portal operations and deep understanding of GST laws, we make your tax compliance hassle-free while maximizing input tax credit benefits.
              </p>

              <div className="mt-8">
                <h3 className="text-2xl font-bold text-blue-600 mb-4">
                  Key Features & Benefits
                </h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Complete Compliance:</strong> Ensure 100% compliance with all GST return filing requirements and avoid penalties.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Timely Filing:</strong> All returns filed before due dates (GSTR-1: 11th, GSTR-3B: 20th/22nd/24th of following month).
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Input Tax Credit Optimization:</strong> Maximize your ITC claims through proper documentation and reconciliation.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">GST Portal Expertise:</strong> Expert handling of GST portal including filing, payments, and amendment requests.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Reconciliation Services:</strong> Monthly reconciliation of GSTR-2A/2B with purchase records to optimize ITC.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Multi-State Compliance:</strong> Handle GST compliance for businesses operating across multiple states.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Annual Return Filing:</strong> Comprehensive GSTR-9 and GSTR-9C filing for complete annual compliance.
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-1" id="contact-section">
              <div className="bg-gray-50 p-6 rounded-xl shadow-xl border-t-4 border-blue-600 sticky top-28">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                  Quick Enquiry
                </h3>
                
                {formStatus === 'success' && (
                  <div className="p-4 bg-green-100 text-green-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">✅</span>
                    Thank you! Your enquiry has been submitted. We'll contact you shortly.
                  </div>
                )}

                {formStatus === 'error' && (
                  <div className="p-4 bg-red-100 text-red-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">❌</span>
                    There was an error submitting your form. Please try again.
                  </div>
                )}

                <form className="space-y-4" onSubmit={handleFormSubmit}>
                  <input 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Your Full Name" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Email Address" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="tel" 
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Phone Number" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <textarea 
                    rows="3" 
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="I need help with GST Return Filing." 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required
                  ></textarea>
                  <button 
                    type="submit" 
                    disabled={isSubmitting}
                    className="w-full py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition disabled:bg-blue-400 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? (
                      <>
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3 inline-block"></div>
                        Submitting...
                      </>
                    ) : (
                      'Request an Initial Consultation'
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Procedure Section */}
      <section id="procedure" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Our Comprehensive Process
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              8 Steps for GST Return Filing
            </p>
          </div>
          
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-4 grid-flow-row-dense">
            {[
              { number: "01", icon: "📄", title: "Data Collection & Verification", desc: "Collect sales invoices, purchase bills, debit/credit notes, and verify GSTIN details of suppliers/customers." },
              { number: "02", icon: "🧮", title: "Tax Calculation", desc: "Calculate CGST, SGST, IGST liabilities and eligible input tax credit based on invoice-level data." },
              { number: "03", icon: "🔄", title: "GSTR-2A/2B Reconciliation", desc: "Reconcile purchase data with GSTR-2A/2B to identify missing invoices and optimize input tax credit." },
              { number: "04", icon: "📤", title: "GSTR-1 Preparation & Filing", desc: "Prepare and file GSTR-1 (outward supplies) with invoice-level details by 11th of following month." },
              { number: "05", icon: "💳", title: "Tax Payment Processing", desc: "Generate GST PMT-06 challan and process tax payments through various online payment modes." },
              { number: "06", icon: "✅", title: "GSTR-3B Filing", desc: "File GSTR-3B summary return with tax liability details and payment confirmation by due date." },
              { number: "07", icon: "🔍", title: "Return Verification", desc: "Verify filed returns, generate ARN, and ensure successful submission on GST portal." },
              { number: "08", icon: "🏆", title: "Compliance Certificate", desc: "Provide filing acknowledgements, payment receipts, and monthly compliance certificate." }
            ].map((step, index) => (
              <div key={index} className="sm:col-span-2 lg:col-span-2 flex flex-col justify-between p-3 bg-white rounded-xl shadow-md text-center hover:shadow-lg transition-shadow border-t-4 border-blue-500">
                <div className="flex flex-col flex-grow justify-center">
                  <span className="text-xl font-extrabold text-blue-600 block leading-tight">{step.number}</span>
                  <span className="text-2xl mx-auto block leading-none">{step.icon}</span>
                  <h3 className="text-base font-semibold text-gray-900 leading-snug mt-0.5">{step.title}</h3>
                  <p className="text-gray-600 text-sm text-justify mt-1 leading-snug">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Documents Section */}
      <section id="documents" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Documents Required for GST Filing
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Mandatory Documents for Monthly Compliance
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: "🧾", title: "Sales Invoices", desc: "All outward supply invoices with GSTIN, HSN codes, and tax breakdown." },
              { icon: "🛒", title: "Purchase Bills", desc: "All inward supply invoices from registered suppliers for ITC claims." },
              { icon: "📝", title: "Debit/Credit Notes", desc: "All amendment documents for sales/purchase adjustments during the month." },
              { icon: "💰", title: "Bank Statements", desc: "Bank statements showing GST payments and refund receipts, if any." },
              { icon: "🚚", title: "Export Documents", desc: "Shipping bills, ARE-1 forms for export supplies with LUT details." },
              { icon: "📦", title: "Stock Records", desc: "Stock registers for goods sent/received on approval basis." },
              { icon: "🆔", title: "GST Registration", desc: "GST registration certificate and any amendment certificates." },
              { icon: "📋", title: "Previous Returns", desc: "Last filed GST returns for continuity and amendment tracking." },
              { icon: "✉️", title: "Authorization Letter", desc: "Authorization for consultant to file returns on company's behalf." }
            ].map((doc, index) => (
              <div key={index} className="p-6 border rounded-xl shadow-md flex items-start space-x-4 h-full">
                <span className="text-2xl flex-shrink-0 mt-1">{doc.icon}</span>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">{doc.title}</h3>
                  <p className="text-gray-600 text-sm mt-1 text-justify">{doc.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What You Get Section */}
      <section id="you-get" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Your Deliverables
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              What Akir Advisory Delivers
            </p>
          </div>

          {/* 5 equal boxes in a single row */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {[
              { icon: "✅", title: "Filed Return Acknowledgements", desc: "Monthly filing acknowledgements for GSTR-1 and GSTR-3B with ARN numbers from GST portal." },
              { icon: "💳", title: "Payment Challans & Receipts", desc: "Complete set of GST PMT-06 challans and bank payment receipts for tax payments made." },
              { icon: "🔄", title: "ITC Reconciliation Report", desc: "Monthly input tax credit reconciliation report comparing purchase data with GSTR-2A/2B." },
              { icon: "📅", title: "Compliance Calendar", desc: "Monthly GST compliance calendar with all filing deadlines and payment due dates." },
              { icon: "🎧", title: "Ongoing Support Services", desc: "Monthly reminder services, GST law updates, notice handling support, annual return filing (GSTR-9/9C)" }
            ].map((item, index) => (
              <div key={index} className="p-5 bg-white rounded-xl shadow-lg border-l-4 border-green-500 flex flex-col h-full">
                <span className="text-2xl mb-2 block">{item.icon}</span>
                <h3 className="text-lg font-bold text-gray-900 mb-1">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-snug">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQs Section */}
      <section id="service-faqs" className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-12">
                  <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
                      Common Questions
                  </h2>
                  <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                      GST Return Filing FAQs
                  </p>
              </div>
              
              <div className="space-y-4 max-w-4xl mx-auto">
                {[
                  { 
                    question: "What are the due dates for GST return filing?", 
                    answer: "GSTR-1: 11th of following month, GSTR-3B: 20th/22nd/24th based on state, GSTR-9: 31st December following financial year." 
                  },
                  { 
                    question: "What is the penalty for late filing of GST returns?", 
                    answer: "Late fee of ₹50 per day (₹25 CGST + ₹25 SGST) for GSTR-1 and ₹20 per day for GSTR-3B, subject to maximum limits." 
                  },
                  { 
                    question: "What is GSTR-2A/2B reconciliation and why is it important?", 
                    answer: "Reconciliation of purchase records with auto-populated data in GSTR-2A/2B is crucial to claim correct input tax credit and avoid ITC reversal." 
                  },
                  { 
                    question: "Can we revise GST returns after filing?", 
                    answer: "GST returns cannot be revised. Amendments can be made in subsequent returns through debit/credit notes or amendment returns." 
                  },
                  { 
                    question: "What is the difference between GSTR-1 and GSTR-3B?", 
                    answer: "GSTR-1 contains invoice-level outward supply details, while GSTR-3B is a summary return for tax payment and ITC claims." 
                  },
                  { 
                    question: "Is annual return filing mandatory for all businesses?", 
                    answer: "GSTR-9 is mandatory for all regular taxpayers with annual turnover above ₹2 crore. GSTR-9C (reconciliation) is required above ₹5 crore." 
                  }
                ].map((faq, index) => (
                  <div key={index} className="border rounded-lg p-5 shadow-sm">
                    <h4 className="font-semibold text-lg text-gray-900 mb-2">{faq.question}</h4>
                    <p className="text-gray-600">{faq.answer}</p>
                  </div>
                ))}
              </div>
          </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-16 bg-blue-700/90">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-extrabold text-white">
                Ready for GST Compliance?
            </h2>
            <p className="mt-4 text-xl text-blue-100 max-w-3xl mx-auto">
                Let our team of GST experts handle your monthly compliance and maximize your input tax credit benefits.
            </p>
            <a href="#contact-section" className="mt-8 inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                <span className="mr-2">📞</span> Consult Our GST Expert Today
            </a>
        </div>
      </section>
    </main>
  );
};

export default GSTReturnFiling;